define(function () {
    'use strict'

    /**
     * @exports bind
     *
     * @param {*} value The object.
     * @returns {Object} Returns true if the object is defined, returns false otherwise.
     *
     */
    const bind = (Module) => {
        const quit = Module.cwrap('quit', 'null', ['null'])

        const Uuid_New = Module.cwrap('Uuid_New', 'number', ['null'])
        const Uuid_SetId = Module.cwrap('Uuid_SetId', 'null', ['number', 'number'])
        const Uuid_GetId = Module.cwrap('Uuid_GetId', 'string', ['number'])
        const Uuid_Delete = Module.cwrap('Uuid_Delete', 'null', ['number'])

        const ObjectName_New = Module.cwrap('ObjectName_New', 'number', ['null'])
        const ObjectName_SetObjectId = Module.cwrap('ObjectName_SetObjectId', 'null', ['number', 'number'])
        const ObjectName_GetObjectId = Module.cwrap('ObjectName_GetObjectId', 'number', ['number'])
        const ObjectName_SetName = Module.cwrap('ObjectName_SetName', 'null', ['number', 'number'])
        const ObjectName_GetName = Module.cwrap('ObjectName_GetName', 'string', ['number'])
        const ObjectName_Delete = Module.cwrap('ObjectName_Delete', 'null', ['number'])

        const ObjectType_New = Module.cwrap('ObjectType_New', 'number', ['null'])
        const ObjectType_SetCategory = Module.cwrap('ObjectType_SetCategory', 'null', ['number', 'number'])
        const ObjectType_GetCategory = Module.cwrap('ObjectType_GetCategory', 'string', ['number'])
        const ObjectType_SetName = Module.cwrap('ObjectType_SetName', 'null', ['number', 'number'])
        const ObjectType_GetName = Module.cwrap('ObjectType_GetName', 'string', ['number'])
        const ObjectType_Delete = Module.cwrap('ObjectType_Delete', 'null', ['number'])

        const ObjectProerty_New = Module.cwrap('ObjectProerty_New', 'number', ['null'])
        const ObjectProerty_SetObjectId = Module.cwrap('ObjectProerty_SetObjectId', 'null', ['number', 'number'])
        const ObjectProerty_GetObjectId = Module.cwrap('ObjectProerty_GetObjectId', 'number', ['number'])
        const ObjectProerty_SetProperty = Module.cwrap('ObjectProerty_SetProperty', 'null', ['number', 'number'])
        const ObjectProerty_GetProperty = Module.cwrap('ObjectProerty_GetProperty', 'number', ['number'])
        const ObjectProerty_Delete = Module.cwrap('ObjectProerty_Delete', 'null', ['number'])

        const Property_New = Module.cwrap('Property_New', 'number', ['null'])
        const Property_SetName = Module.cwrap('Property_SetName', 'null', ['number', 'number'])
        const Property_GetName = Module.cwrap('Property_GetName', 'string', ['number'])
        const Property_SetValue = Module.cwrap('Property_SetValue', 'null', ['number', 'number'])
        const Property_GetValue = Module.cwrap('Property_GetValue', 'string', ['number'])
        const Property_SetIsWritable = Module.cwrap('Property_SetIsWritable', 'null', ['number', 'boolean'])
        const Property_GetIsWritable = Module.cwrap('Property_GetIsWritable', 'boolean', ['number'])
        const Property_Delete = Module.cwrap('Property_Delete', 'null', ['number'])

        const AvatarInformation_New = Module.cwrap('AvatarInformation_New', 'number', ['null'])
        const AvatarInformation_SetName = Module.cwrap('AvatarInformation_SetName', 'null', ['number', 'number'])
        const AvatarInformation_GetName = Module.cwrap('AvatarInformation_GetName', 'string', ['number'])
        const AvatarInformation_SetUuid = Module.cwrap('AvatarInformation_SetUuid', 'null', ['number', 'number'])
        const AvatarInformation_GetUuid = Module.cwrap('AvatarInformation_GetUuid', 'number', ['number'])
        const AvatarInformation_SetObjectType = Module.cwrap('AvatarInformation_SetObjectType', 'null', ['number', 'number'])
        const AvatarInformation_GetObjectType = Module.cwrap('AvatarInformation_GetObjectType', 'number', ['number'])
        const AvatarInformation_Delete = Module.cwrap('AvatarInformation_Delete', 'null', ['number'])

        const AvatarInformationList_New = Module.cwrap('AvatarInformationList_New', 'number', ['null'])
        const AvatarInformationList_AddAvatarInformation = Module.cwrap('AvatarInformationList_AddAvatarInformation', 'null', ['number', 'number'])
        const AvatarInformationList_GetAvatarInformationsSize = Module.cwrap('AvatarInformationList_GetAvatarInformationsSize', 'number', ['number'])
        const AvatarInformationList_GetAvatarInformation = Module.cwrap('AvatarInformationList_GetAvatarInformation', 'number', ['number', 'number'])
        const AvatarInformationList_ClearAvatarInformations = Module.cwrap('AvatarInformationList_ClearAvatarInformations', 'null', ['number'])
        const AvatarInformationList_Delete = Module.cwrap('AvatarInformationList', 'null', ['number'])

        const AvatarComponent_New = Module.cwrap('AvatarComponent_New', 'number', ['null'])
        const AvatarComponent_SetUuid = Module.cwrap('AvatarComponent_SetUuid', 'null', ['number', 'number'])
        const AvatarComponent_GetUuid = Module.cwrap('AvatarComponent_GetUuid', 'number', ['number'])
        const AvatarComponent_SetObjectType = Module.cwrap('AvatarComponent_SetObjectType', 'null', ['number', 'number'])
        const AvatarComponent_GetObjectType = Module.cwrap('AvatarComponent_GetObjectType', 'number', ['number'])
        const AvatarComponent_GetProperty = Module.cwrap('AvatarComponent_GetProperty', 'number', ['number', 'number'])
        const AvatarComponent_GetPropertiesSize = Module.cwrap('AvatarComponent_GetPropertiesSize', 'number', ['number'])
        const AvatarComponent_ClearProperties = Module.cwrap('AvatarComponent_ClearProperties', 'null', ['number'])
        const AvatarComponent_AddProperty = Module.cwrap('AvatarComponent_AddProperty', 'null', ['number', 'number'])
        const AvatarComponent_Delete = Module.cwrap('AvatarComponent_Delete', 'null', ['number'])

        const Avatar_SetAvatarInformation = Module.cwrap('Avatar_SetAvatarInformation', 'null', ['number', 'number'])
        const Avatar_GetAvatarInformation = Module.cwrap('Avatar_GetAvatarInformation', 'number', ['number'])
        const Avatar_GetProperty = Module.cwrap('Avatar_GetProperty', 'number', ['number', 'number'])
        const Avatar_GetPropertiesSize = Module.cwrap('Avatar_GetPropertiesSize', 'number', ['number'])
        const Avatar_ClearProperties = Module.cwrap('Avatar_ClearProperties', 'null', ['number'])
        const Avatar_AddProperty = Module.cwrap('Avatar_AddProperty', 'null', ['number', 'number'])
        const Avatar_GetAvatarComponent = Module.cwrap('Avatar_GetAvatarComponent', 'number', ['number', 'number'])
        const Avatar_GetAvatarComponentsSize = Module.cwrap('Avatar_GetAvatarComponentsSize', 'number', ['number'])
        const Avatar_ClearAvatarComponents = Module.cwrap('Avatar_ClearAvatarComponents', 'null', ['number'])
        const Avatar_AddAvatarComponent = Module.cwrap('Avatar_AddAvatarComponent', 'null', ['number', 'number'])
        const Avatar_Delete = Module.cwrap('Avatar_Delete', 'null', ['number'])

        const AvatarAndComponentId_New = Module.cwrap('AvatarAndComponentId_New', 'number', ['null'])
        const AvatarAndComponentId_SetAvatarId = Module.cwrap('AvatarAndComponentId_SetAvatarId', 'null', ['number', 'number'])
        const AvatarAndComponentId_GetAvatarId = Module.cwrap('AvatarAndComponentId_GetAvatarId', 'number', ['number'])
        const AvatarAndComponentId_SetComponentId = Module.cwrap('AvatarAndComponentId_SetComponentId', 'null', ['number', 'number'])
        const AvatarAndComponentId_GetComponentId = Module.cwrap('AvatarAndComponentId_GetComponentId', 'number', ['number'])
        const AvatarAndComponentId_Delete = Module.cwrap('AvatarAndComponentId_Delete', 'null', ['number'])

        const CreateComponentType_New = Module.cwrap('CreateComponentType_New', 'number', ['null'])
        const CreateComponentType_SetAvatarId = Module.cwrap('CreateComponentType_SetAvatarId', 'null', ['number', 'number'])
        const CreateComponentType_GetAvatarId = Module.cwrap('CreateComponentType_GetAvatarId', 'number', ['number'])
        const CreateComponentType_SetObjectType = Module.cwrap('CreateComponentType_SetObjectType', 'null', ['number', 'number'])
        const CreateComponentType_GetObjectType = Module.cwrap('CreateComponentType_GetObjectType', 'number', ['number'])
        const CreateComponentType_Delete = Module.cwrap('CreateComponentType_Delete', 'null', ['number'])

        const ComponentProperty_New = Module.cwrap('ComponentProperty_New', 'number', ['null'])
        const ComponentProperty_SetAvatarId = Module.cwrap('ComponentProperty_SetAvatarId', 'null', ['number', 'number'])
        const ComponentProperty_GetAvatarId = Module.cwrap('ComponentProperty_GetAvatarId', 'number', ['number'])
        const ComponentProperty_SetObjectProerty = Module.cwrap('ComponentProperty_SetObjectProerty', 'null', ['number', 'number'])
        const ComponentProperty_GetObjectProerty = Module.cwrap('ComponentProperty_GetObjectProerty', 'number', ['number'])
        const ComponentProperty_Delete = Module.cwrap('ComponentProperty_Delete', 'null', ['number'])

        const ConnectInfo_New = Module.cwrap('ConnectInfo_New', 'number', ['null'])
        const ConnectInfo_SetQueryInfo = Module.cwrap('ConnectInfo_SetQueryInfo', 'null', ['number', 'number'])
        const ConnectInfo_GetQueryInfo = Module.cwrap('ConnectInfo_GetQueryInfo', 'number', ['number'])
        const ConnectInfo_SetUrl = Module.cwrap('ConnectInfo_SetUrl', 'null', ['number', 'number'])
        const ConnectInfo_GetUrl = Module.cwrap('ConnectInfo_GetUrl', 'string', ['number'])
        const ConnectInfo_Delete = Module.cwrap('ConnectInfo_Delete', 'null', ['number'])

        const GeoDraggerResponse_SetType = Module.cwrap('GeoDraggerResponse_SetType', 'null', ['string'])
        const GeoDraggerResponse_GetType = Module.cwrap('GeoDraggerResponse_GetType', 'string', ['null'])

        const MapImpl_createAndAddAvatar = Module.cwrap('MapImpl_createAndAddAvatar', 'number', ['number'])
        const MapImpl_removeAvatar = Module.cwrap('MapImpl_removeAvatar', 'null', ['number'])
        const MapImpl_getAvatar = Module.cwrap('MapImpl_getAvatar', 'number', ['number'])
        const MapImpl_getAllAvatars = Module.cwrap('MapImpl_getAllAvatars', 'number', ['null'])
        const MapImpl_listAvatar = Module.cwrap('MapImpl_listAvatar', 'number', ['string'])
        const MapImpl_flyTo = Module.cwrap('MapImpl_flyTo', 'null', ['number'])
        const MapImpl_jumpTo = Module.cwrap('MapImpl_jumpTo', 'null', ['number'])

        const AvatarImpl_createAndAddComponent = Module.cwrap('AvatarImpl_createAndAddComponent', 'number', ['number'])
        const AvatarImpl_removeComponent = Module.cwrap('AvatarImpl_removeComponent', 'null', ['number'])
        const AvatarImpl_setName = Module.cwrap('AvatarImpl_setName', 'null', ['number'])
        const AvatarImpl_setProperty = Module.cwrap('AvatarImpl_setProperty', 'null', ['number'])
        const AvatarImpl_getProperty = Module.cwrap('AvatarImpl_getProperty', 'number', ['number'])
        const AvatarImpl_refresh = Module.cwrap('AvatarImpl_refresh', 'null', ['number'])

        const ComponentImpl_setProperty = Module.cwrap('ComponentImpl_setProperty', 'null', ['number'])
        const ComponentImpl_getProperty = Module.cwrap('ComponentImpl_getProperty', 'number', ['number'])
        const ComponentImpl_refresh = Module.cwrap('ComponentImpl_refresh', 'null', ['number'])
        const ComponentImpl_connect = Module.cwrap('ComponentImpl_connect', 'boolean', ['number'])

        const Window3DImpl_reset = Module.cwrap('Window3DImpl_reset', 'null', ['number', 'number', 'number', 'number'])

        const EditorImpl_listeningGeoDragger = Module.cwrap('EditorImpl_listeningGeoDragger', 'null', ['null'])
        const register_js_MapImpl_createAndAddAvatar_callback_function = Module.cwrap('register_js_MapImpl_createAndAddAvatar_callback_function', 'null', ['number'])

        const LoadAvatarAndComponent = Module.cwrap('LoadAvatarAndComponent', 'string', ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'number', 'boolean', 'boolean'])
        const LoadAvatarAndMultiComponent = Module.cwrap('LoadAvatarAndMultiComponent', 'string', ['number', 'number', 'number', 'number', 'boolean', 'boolean', 'boolean'])
        const UpdateAvatarAndComponent = Module.cwrap('UpdateAvatarAndComponent', 'null', ['number', 'number', 'number', 'number'])
        const UpdateAvatarAndMultiComponent = Module.cwrap('UpdateAvatarAndMultiComponent', 'null', ['number', 'number', 'number', 'number'])
        const LocateAvatar = Module.cwrap('LocateAvatar', 'null', ['number'])
        const RemoveAvatar = Module.cwrap('RemoveAvatar', 'null', ['number'])
        const GetViewLocation = Module.cwrap('GetViewLocation', 'string', ['null'])
        const SetViewLocation = Module.cwrap('SetViewLocation', 'null', ['number'])
        const FlyToViewLocation = Module.cwrap('FlyToViewLocation', 'null', ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number'])
        const LoadPresentation = Module.cwrap('LoadPresentation', 'string', ['null'])
        const UpdatePresentation = Module.cwrap('UpdatePresentation', 'null', ['number', 'number', 'number'])
        const CreatePresentationItem = Module.cwrap('CreatePresentationItem', 'string', ['number', 'number', 'number', 'number', 'number', 'number',])
        const GetPresentationItem = Module.cwrap('GetPresentationItem', 'string', ['number', 'number', 'boolean'])
        const EnablePicker = Module.cwrap('EnablePicker', 'null', ['boolean', 'boolean'])
        const ResetPicker = Module.cwrap('ResetPicker', 'null', ['null'])
        const SetDraggerObject = Module.cwrap('SetDraggerObject', 'null', ['number'])
        const EnableRoam = Module.cwrap('EnableRoam', 'null', ['boolean'])
        const LoadModel = Module.cwrap('LoadModel', 'string', ['number', 'number', 'boolean'])
        const LoadModelWithAI = Module.cwrap('LoadModelWithAI', 'string', ['number', 'number', 'number', 'boolean'])
        const LoadModelWithMouse = Module.cwrap('LoadModelWithMouse', 'string', ['number'])
        const LoadModelWithMouseAI = Module.cwrap('LoadModelWithMouseAI', 'string', ['number', 'number', 'number'])
        const CoordinateTransformation = Module.cwrap('CoordinateTransformation', 'string', ['number', 'boolean', 'boolean', 'number'])
        const CalCirclePoints = Module.cwrap('CalCirclePoints', 'string', ['number', 'number', 'number', 'number', 'number'])
        const SetLodScale = Module.cwrap('SetLodScale', 'null', ['number'])
        const SetAvatarOrientation = Module.cwrap('SetAvatarOrientation', 'null', ['number', 'number', 'number','number','number','number','number'])

        const SetTimeScale = Module.cwrap('SetTimeScale', 'null', ['number'])
        const SetTimeZone = Module.cwrap('SetTimeZone', 'null', ['number'])
        const SetTime = Module.cwrap('SetTime', 'null', ['number'])
        const GetTime = Module.cwrap('GetTime', 'string', ['null'])
        const ControlTime = Module.cwrap('ControlTime', 'null', ['number'])
        const SetTimeIntervalType = Module.cwrap('SetTimeIntervalType', 'null', ['number'])
        const GetTimeInterval = Module.cwrap('GetTimeInterval', 'number', ['null'])
        const MemoryTest = Module.cwrap('MemoryTest', 'null', ['number', 'number'])
        const MemoryInfo = Module.cwrap('MemoryInfo', 'number', ['null'])
        const GetDataRequest = Module.cwrap('GetDataRequest', 'number', ['null'])
        const GetNodes = Module.cwrap('GetNodes', 'number', ['null'])
        const GetActiveNodes = Module.cwrap('GetActiveNodes', 'number', ['null'])
        return {
            quit,

            Uuid_New,
            Uuid_SetId,
            Uuid_GetId,
            Uuid_Delete,

            ObjectName_New,
            ObjectName_SetObjectId,
            ObjectName_GetObjectId,
            ObjectName_SetName,
            ObjectName_GetName,
            ObjectName_Delete,

            ObjectType_New,
            ObjectType_SetCategory,
            ObjectType_GetCategory,
            ObjectType_SetName,
            ObjectType_GetName,
            ObjectType_Delete,

            ObjectProerty_New,
            ObjectProerty_SetObjectId,
            ObjectProerty_GetObjectId,
            ObjectProerty_SetProperty,
            ObjectProerty_GetProperty,
            ObjectProerty_Delete,

            Property_New,
            Property_SetName,
            Property_GetName,
            Property_SetValue,
            Property_GetValue,
            Property_SetIsWritable,
            Property_GetIsWritable,
            Property_Delete,

            AvatarInformation_New,
            AvatarInformation_SetName,
            AvatarInformation_GetName,
            AvatarInformation_SetUuid,
            AvatarInformation_GetUuid,
            AvatarInformation_SetObjectType,
            AvatarInformation_GetObjectType,
            AvatarInformation_Delete,

            AvatarInformationList_New,
            AvatarInformationList_AddAvatarInformation,
            AvatarInformationList_GetAvatarInformationsSize,
            AvatarInformationList_GetAvatarInformation,
            AvatarInformationList_ClearAvatarInformations,
            AvatarInformationList_Delete,

            AvatarComponent_New,
            AvatarComponent_SetUuid,
            AvatarComponent_GetUuid,
            AvatarComponent_SetObjectType,
            AvatarComponent_GetObjectType,
            AvatarComponent_GetProperty,
            AvatarComponent_GetPropertiesSize,
            AvatarComponent_ClearProperties,
            AvatarComponent_AddProperty,
            AvatarComponent_Delete,

            Avatar_SetAvatarInformation,
            Avatar_GetAvatarInformation,
            Avatar_GetProperty,
            Avatar_GetPropertiesSize,
            Avatar_ClearProperties,
            Avatar_AddProperty,
            Avatar_GetAvatarComponent,
            Avatar_GetAvatarComponentsSize,
            Avatar_ClearAvatarComponents,
            Avatar_AddAvatarComponent,
            Avatar_Delete,

            AvatarAndComponentId_New,
            AvatarAndComponentId_SetAvatarId,
            AvatarAndComponentId_GetAvatarId,
            AvatarAndComponentId_SetComponentId,
            AvatarAndComponentId_GetComponentId,
            AvatarAndComponentId_Delete,

            CreateComponentType_New,
            CreateComponentType_SetAvatarId,
            CreateComponentType_GetAvatarId,
            CreateComponentType_SetObjectType,
            CreateComponentType_GetObjectType,
            CreateComponentType_Delete,

            ComponentProperty_New,
            ComponentProperty_SetAvatarId,
            ComponentProperty_GetAvatarId,
            ComponentProperty_SetObjectProerty,
            ComponentProperty_GetObjectProerty,
            ComponentProperty_Delete,

            ConnectInfo_New,
            ConnectInfo_SetQueryInfo,
            ConnectInfo_GetQueryInfo,
            ConnectInfo_SetUrl,
            ConnectInfo_GetUrl,
            ConnectInfo_Delete,

            GeoDraggerResponse_SetType,
            GeoDraggerResponse_GetType,

            MapImpl_createAndAddAvatar,
            MapImpl_removeAvatar,
            MapImpl_getAvatar,
            MapImpl_getAllAvatars,
            MapImpl_listAvatar,
            MapImpl_flyTo,
            MapImpl_jumpTo,

            AvatarImpl_createAndAddComponent,
            AvatarImpl_removeComponent,
            AvatarImpl_setName,
            AvatarImpl_setProperty,
            AvatarImpl_getProperty,
            AvatarImpl_refresh,

            ComponentImpl_setProperty,
            ComponentImpl_getProperty,
            ComponentImpl_refresh,
            ComponentImpl_connect,

            Window3DImpl_reset,

            EditorImpl_listeningGeoDragger,
            register_js_MapImpl_createAndAddAvatar_callback_function,

            LoadAvatarAndComponent,
            LoadAvatarAndMultiComponent,
            UpdateAvatarAndComponent,
            UpdateAvatarAndMultiComponent,
            LocateAvatar,
            RemoveAvatar,
            GetViewLocation,
            SetViewLocation,
            FlyToViewLocation,
            LoadPresentation,
            UpdatePresentation,
            CreatePresentationItem,
            GetPresentationItem,
            EnablePicker,
            ResetPicker,
            SetDraggerObject,
            EnableRoam,
            LoadModel,
            LoadModelWithAI,
            LoadModelWithMouse,
            LoadModelWithMouseAI,
            CoordinateTransformation,
            CalCirclePoints,
            SetLodScale,
            SetAvatarOrientation,
            SetTimeScale,
            SetTimeZone,
            SetTime,
            GetTime,
            ControlTime,
            SetTimeIntervalType,
            GetTimeInterval,
            MemoryTest,
            MemoryInfo,
            GetDataRequest,
            GetNodes,
            GetActiveNodes
        }
    }

    return bind
})

